<template>
  <div class="detail-sign-info">
    <el-form :inline="true" :model="signInfo">
      <div class="sign-form clearfix">
        <div class="top-box">
          <div class="form-item">
            <el-form-item label="用户身份:">
              <el-select
                v-model="signInfo.userType"
                placeholder="请选择身份"
                class="option-width"
                clearable
              >
                <el-option
                  v-for="item in occupInfo"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-item item_bto">
            <el-form-item label="审核状态:">
              <el-select
                v-model="signInfo.verifyStatus"
                placeholder="请选择状态"
                class="option-width"
                clearable
              >
                <el-option
                  v-for="item in stateInfo"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-item item_bto">
            <el-form>
              <el-form-item label="用户地区:">
                <el-select
                  v-model="signInfo.cityCode"
                  placeholder="请选择地区"
                  class="option-width"
                  clearable
                >
                  <el-option
                    v-for="item in cityCodeList"
                    :key="item.id"
                    :label="item.areaName"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="form-item item_bto">
            <el-form-item label="基本信息:">
              <el-input
                placeholder="请输入姓名/手机号"
                v-model="signInfo.userName"
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="bottom-box">
          <div class="form-item">
            <el-form-item label="参赛平台:">
              <el-input
                placeholder="请输入参赛平台"
                v-model="signInfo.type"
                class="paltform-name"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item item_bto">
            <el-form-item label="身份证号:">
              <el-input
                placeholder="请输入身份证号"
                v-model="signInfo.idCard"
                class="paltform-name"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item item_bto">
            <el-form-item label="报名时间:">
              <el-date-picker
                size="small"
                v-model="valueDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="dateChange"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="form-item item_btn">
            <el-form-item
              ><el-button type="primary" @click="queryRegisterList(11)">
                查询
              </el-button>
              <el-button type="warning" @click="chongzhi">重置</el-button>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>

    <el-row
      :style="{ marginTop: '10px', marginBottom: '10px' }"
      align="middle"
      type="flex"
      class="row-bg"
    >
      <el-button
        type="info"
        size="small"
        @click="goBack"
        icon="el-icon-arrow-left"
        >返回</el-button
      >
      <!-- 导出按钮 -->

      <el-button type="info" @click="getcommand"> 导出到excel </el-button>

      <!-- 批量删除按钮 -->
      <el-button
        type="info"
        :style="{ marginLeft: '10px' }"
        @click="multipleDelete"
        :disabled="deleteIds.length < 1"
      >
        批量删除
      </el-button>
      <el-button
        type="success"
        :disabled="deleteIds.length < 1"
        @click="approved('1')"
        >审核通过</el-button
      >
      <el-button
        type="danger"
        :disabled="deleteIds.length < 1"
        @click="auditFailed('2')"
        >审核不通过</el-button
      >
      <el-button type="warning" @click="addOrUpdateHandle(activitiesids)"
        >数据统计</el-button
      >
      <!-- 成绩导出 -->
      <!-- <el-button type="warning" @click="dialogTableVisible = true"
        >成绩导出
      </el-button>
      <el-dialog
        title="成绩导出"
        :visible.sync="dialogTableVisible"
        width="450px"
      >
        <el-form>
          <el-form-item label="活动赛区" label-width="120px">
            <el-select
              v-model="signInfo.cityCode"
              placeholder="请选择活动区域"
              ref="selectValue"
            >
              <el-option
                v-for="item in cityCodeList"
                :key="item.code"
                :label="item.areaName"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogTableVisible = false">取 消</el-button>
          <el-button type="primary" @click="outExcel">确定导出</el-button>
        </div>
      </el-dialog> -->
    </el-row>

    <!-- <el-alert
      :title="activitiesName"
      type="info"
      :closable="false"
      effect="dark"
      show-icon
      center
    >
    </el-alert> -->

    <el-table
      :data="personList"
      height="500"
      border
      style="width: 100%"
      stripe
      @selection-change="selectPersons"
      id="tableform"
      v-loading="loading"
    >
      <el-table-column type="selection" width="40"> </el-table-column>
      <el-table-column
        type="index"
        width="40"
        :index="(signInfo.commonDto.page - 1) * signInfo.commonDto.limit + 1"
        label="#"
      >
      </el-table-column>
      <div class="" v-for="(item, index) in mubanlist.input" :key="index">
        <el-table-column
          :label="item.name"
          align="center"
          width="100"
          show-overflow-tooltip
          :prop="item.attribute"
        >
        </el-table-column>
      </div>
      <div class="" v-for="(item, index) in mubanlist.upload" :key="index">
        <el-table-column
          :label="item.name"
          align="center"
          width="100"
          show-overflow-tooltip
          :prop="item.attribute"
        >
        </el-table-column>
      </div>
      <el-table-column
        label="账号昵称"
        align="center"
        width="90"
        show-overflow-tooltip
        prop="userName"
      >
      </el-table-column>
      <el-table-column
        label="直播昵称"
        align="center"
        width="90"
        show-overflow-tooltip
        prop="otherInfo.LiveName"
      >
      </el-table-column>
      <el-table-column
        label="直播Id"
        align="center"
        width="100"
        show-overflow-tooltip
        prop="otherInfo.Liveaccount"
      >
      </el-table-column>
      <el-table-column
        label="手机号码"
        align="center"
        width="120"
        show-overflow-tooltip
        prop="phone"
      >
      </el-table-column>
      <el-table-column
        prop="idCard"
        label="身份证号"
        align="center"
        width="180"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column label="参赛平台" align="center" width="80">
        <template slot-scope="scope">
          <!-- <el-tag type="primary" size="small">
            {{ scope.row.type }}
          </el-tag> -->
          <span> {{ scope.row.type }}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户地区" align="center" width="80">
        <template slot-scope="scope">
          <!-- <el-tag type="primary" v-if="cityCodeList.length" size="small">
            {{
              cityName(scope.row.cityCode)
                ? cityName(scope.row.cityCode).areaName
                : null
            }}
          </el-tag> -->
          <span type="primary" v-if="cityCodeList.length" size="small">
            {{
              cityName(scope.row.cityCode)
                ? cityName(scope.row.cityCode).areaName
                : null
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="用户身份" align="center" width="80">
        <template slot-scope="scope">
          <!-- <el-tag type="primary" size="small">
            {{ scope.row.userType === "1" ? "在校学生" : "社会人士" }}
          </el-tag> -->
          <span type="primary" size="small">
            {{ scope.row.userType === "1" ? "在校学生" : "社会人士" }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="用户身份" align="center" width="100">
        <template slot-scope="scope">
           <span v-html="showcontent(scope.row.Liveintroduce)">
          </span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="createTime"
        label="报名时间"
        align="center"
        width="170"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="otherInfo.Liveintroduce"
        label="直播介绍"
        width="170"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="审核状态" align="center">
        <template slot-scope="scope">
          <!-- <el-tag
            plain
            size="small"
            :type="scope.row.verifyStatus === '2' ? 'danger' : 'primary'"
          >
            {{
              scope.row.verifyStatus === "0"
                ? "待审核"
                : scope.row.verifyStatus === "1"
                ? "审核通过"
                : "审核不通过"
            }}
          </el-tag> -->
          <span
            plain
            size="small"
            :class="scope.row.verifyStatus == '1' ? 'danger' : 'primary'"
          >
            {{
              scope.row.verifyStatus === "0"
                ? "待审核"
                : scope.row.verifyStatus === "1"
                ? "审核通过"
                : "审核不通过"
            }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="verifyDesc"
        label="审核结果描述"
        align="center"
        show-overflow-tooltip
      ></el-table-column> -->
    </el-table>

    <!-- 报名列表分页器 -->
    <el-pagination
      background
      layout="total,prev, pager, next"
      :total="personTotal"
      @current-change="pageChange"
      :page-size="signInfo.commonDto.limit"
      :current-page="signInfo.commonDto.page"
    >
    </el-pagination>
    <!-- 审核新添加列表的弹框 -->
    <!-- <check-status
            :check-query="checkQuery"
            ref="checkRef"
            @updateComputed="getPersonList()"
        /> -->
    <el-dialog
      title="审核原因"
      :visible.sync="examDialogVisible"
      width="30%"
      @close="handleClose"
    >
      <el-input
        type="textarea"
        :rows="3"
        placeholder="请输入审核不通过的原因"
        v-model="mutiAuditQuery.context"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="examDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update ref="addOrUpdateRef" v-if="addOrUpdateVisible" />
  </div>
</template>

<script>
import { showcontent } from "@/utils/method.js";
import AddOrUpdate from "@/views/modules/config/child-components/activities-add-or-tongji";
import table2excel from "js-table2excel";
import axios from "axios";
export default {
  components: {
    AddOrUpdate,
  },
  data() {
    return {
      activitiesids: "",
      addOrUpdateVisible: false,
      //对话框是否展示
      dialogTableVisible: false,
      // 获取报名信息列表参数
      personQuery: {
        acid: null,
      },
      // 报名信息列表
      personList: [],
      mubanlist: [],
      // 报名总人数
      personTotal: 0,
      // 活动名称
      activitiesName: "",
      //  要删除的数据数组/批量审核的数组
      deleteIds: [],
      //报名列表查询条件
      signInfo: {
        activitiesId: null,
        userName: "",
        // phone: "",
        idCard: "",
        type: "",
        commonDto: {
          limit: 10,
          page: 1,
        },
        userType: "",
        verifyStatus: "",
        startTime: "",
        endTime: "",
        cityCode: "",
      },
      // 用户职业信息列表
      occupInfo: [
        { name: "在校学生", id: "1" },
        { name: "社会人士", id: "2" },
      ],
      // 审核状态信息
      stateInfo: [
        { name: "待审核", id: "0" },
        { name: "审核通过", id: "1" },
        { name: "审核不通过", id: "2" },
      ],
      // 批量审核的参数
      mutiAuditQuery: {
        context: "",
        status: "",
      },
      // 控制审核不通过描述框的显示与隐藏
      examDialogVisible: false,
      // 城市信息列表
      cityCodeList: [],
      // 日期时间选择框的值
      valueDate: [],
      // 加载组件的显示隐藏
      loading: false,
      arr: [
        // {
        //   code: "341802",
        //   areaName: "宣州区",
        // },
        {
          code: "341802006",
          areaName: "宣城现代服务业产业园区",
        },
        {
          code: "341821",
          areaName: "郎溪县",
        },
        {
          code: "341823",
          areaName: "泾县",
        },
        {
          code: "341824",
          areaName: "绩溪县",
        },
        {
          code: "341825",
          areaName: "旌德县",
        },
        {
          code: "341871",
          areaName: "宣城经开区",
        },
        {
          code: "341881",
          areaName: "宁国市",
        },
        {
          code: "341882",
          areaName: "广德市",
        },
      ],
    };
  },
  created() {
    this.init();
    this.getCityCode();
  },
  computed: {
    //   对字符串进行转义
    escopeObj() {
      return (str) => {
        return JSON.parse(showcontent(showcontent(str)));
      };
    },
    // 计算所属城市
    cityName() {
      return (code) => {
        return this.cityCodeList.find((item) => item.code === code);
      };
    },
  },
  methods: {
    chongzhi() {
      this.signInfo.type = '' 
      this.signInfo.verifyStatus = '' 
      this.signInfo.cityCode = '' 
      this.signInfo.userName = '' 
      this.signInfo.userType = '' 
      this.signInfo.idCard = '' 
      this.valueDate = [];
      this.getPersonList()
    },
    // 新增或修改活动赛事
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdateRef.init(id);
      });
    },
    showcontent,
    init() {
      this.personQuery.acid = this.$route.params.id;
      this.signInfo.activitiesId = parseInt(this.$route.params.id);
      this.getPersonList();
      this.getactivelist(this.signInfo.activitiesId);
    },
    getactivelist(id) {
      this.$ajaxGet("/activities/info/open/" + id).then(({ data }) => {
        // console.log(data);
        this.templateId = data.data.templateId;
        this.getmubanlist(this.templateId);
        this.activitiesids = data.data.id;
      });
    },
    getmubanlist(id) {
      if (id) {
        this.$ajaxGet("/registrationTemplate/getById/open?id=" + id).then(
          ({ data }) => {
            console.log(data);
            this.mubanlist = JSON.parse(showcontent(data.data.content));
          }
        );
      }
    },
    // 获取报名信息列表函数
    getPersonList() {
      this.loading = true;

      this.$ajaxPost(
        "/sys/activitiesSignupData/search/open",
        this.signInfo
      ).then(({ data }) => {
        if (data.code === 0) {
          data.data.list.forEach((e) => {
            e.idCard = e.idCard.substr(0, 4) + "*******" + e.idCard.substr(-4);
            if (e.otherInfo) {
              e.otherInfo = JSON.parse(showcontent(e.otherInfo));
            }
          });
          this.personList = data.data.list;
          // console.log(this.personList);
          this.personTotal = data.data.totalCount;
          this.loading = false;
          if (this.personList.length !== 0) {
            this.activitiesName = this.personList[0].activities;
          }
        }
      });
    },
    // 分页器页数改变时触发
    pageChange(val) {
      this.signInfo.commonDto.page = val;
      this.getPersonList();
    },

    // 删除个人报名信息
    deletePerson(id) {
      this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteIds.push(id);
          this.deleteInfo(this.deleteIds);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 批量删除报名信息列表
    multipleDelete() {
      this.$confirm("确定要批量删除用户报名数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // let ids = [];
          // for (let i = 0; i < this.deleteIds.length; i++) {
          //     ids[i] = this.deleteIds[i].id;
          // }
          // console.log(ids);
          this.deleteInfo(this.deleteIds);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "删除失败，请联系管理员",
          });
        });
    },
    // 删除报名信息封装
    deleteInfo(ids) {
      this.$ajaxPost("/sys/activitiesSignupData/delete/open", ids)
        .then(({ data }) => {
          console.log(data);
          if (data.code === 0) {
            this.getPersonList();
            this.deleteIds = [];
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            this.deleteIds = [];
            this.$message({
              type: "error",
              message: "删除失败!",
            });
          }
        })
        .catch(() => {
          this.deleteIds = [];
        });
    },
    // 将报名信息导出
    getcommand() {
      axios({
        method: "post",
        url: `/sys/activitiesSignupData/excelExport/open?acid=${this.personQuery.acid.toString()}`,
        responseType: "arraybuffer",
      }).then((res) => {
        console.log(res);
        const data = res.data;
        const url = window.URL.createObjectURL(
          new Blob([data], { type: "application/vnd.ms-excel" })
        );
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.download = "报名列表";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    // 实现报名信息多选
    selectPersons(val) {
      this.deleteIds = val;
      let ids = [];
      for (let i = 0; i < this.deleteIds.length; i++) {
        ids[i] = this.deleteIds[i].id;
      }
      this.deleteIds = [...ids];
    },
    // 返回上一个页面
    goBack() {
      this.$router.back();
    },

    // 审核通过按钮
    approved(status) {
      this.mutiAuditQuery.status = status;
      this.mutiAuditQuery.context = "";
      this.$ajaxPost("/sys/activitiesSignupData/updateBatch/open", {
        ids: this.deleteIds.join(","),
        context: this.mutiAuditQuery.context,
        status: this.mutiAuditQuery.status,
      }).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success("审核成功!");
          this.getPersonList();
        }
      });
    },
    // 审核不通过按钮
    auditFailed(status) {
      this.mutiAuditQuery.status = status;
      this.examDialogVisible = true;
    },
    handleClose() {
      this.$ajaxPost("/sys/activitiesSignupData/updateBatch/open", {
        ids: this.deleteIds.join(","),
        context: this.mutiAuditQuery.context,
        status: this.mutiAuditQuery.status,
      }).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success("审核成功!");
          this.getPersonList();
        }
      });
    },
    // 查询报名信息
    queryRegisterList(id) {
      if (id == 11) {
        this.signInfo.commonDto.page = 1;
      }
      console.log(this.signInfo);
      this.$ajaxPost(
        "/sys/activitiesSignupData/search/open",
        this.signInfo
      ).then(({ data }) => {
        if (data.code === 0) {
          data.data.list.forEach((e) => {
            e.idCard = e.idCard.substr(0, 4) + "*******" + e.idCard.substr(-4);
            e.otherInfo = JSON.parse(showcontent(e.otherInfo));
          });
          this.personList = data.data.list;
          console.log(this.personList);
          this.personTotal = data.data.totalCount;
          // this.loading = false;
          // this.personList = data.data.list;
          // this.personTotal = data.data.totalCount;
          this.$message.success("查询成功!");
        }
        if (data.code === 500) {
          this.personList = [];
          this.personTotal = 0;
          this.$message.success("无匹配结果!");
        }
      });
    },
    // 获取地区编码列表数据
    getCityCode() {
      // this.cityCodeList = data.data;
      if (this.$route.params.id == "13") {
        // 宣城
        this.cityCodeList = this.arr;
        // console.log(this.cityCodeList, 1456);
      } else {
        // 非宣城
        this.$ajaxGet("/cityCode/list/open").then(({ data }) => {
          // console.log(data, "城市编码");
          this.cityCodeList = data.data;
        });
      }
    },
    // 日期变化
    dateChange(val) {
      if (val) {
        this.signInfo.startTime = val[0];
        this.signInfo.endTime = val[1];
      } else {
        this.signInfo.startTime = "";
        this.signInfo.endTime = "";
      }
    },
    //成绩导出
    outExcel() {
      console.log("@", this.$refs.selectValue.value),
        (this.dialogTableVisible = false);
      const column = [
        {
          title: "Name",
          key: "name",
          type: "text",
        },
        {
          title: "Pic",
          key: "pic",
          type: "image",
          width: 80,
          height: 50,
        },
      ];
      const data = [
        {
          name: "xiao",
          age: "18",
          pic: "https://profile.csdnimg.cn/9/8/3/2_xiaoxiaojie12321",
        },
        {
          name: "jie",
          age: "18",
          pic: "http://anhuiec.oss-cn-hangzhou.aliyuncs.com/27de5220c76143d0aac7e4b893d122aa.png",
        },
      ];
      const excelName = "boy";
      table2excel(column, data, excelName);
    },
  },
};
</script>

<style lang="less" scoped>
.detail-sign-info {
  background: #fff;
  padding: 20px;
  margin-top: -10px;
  // font-size: 14px !important;
}
@primaryColor: #409eff;
/deep/.el-table {
  font-size: 14px;
}
.check-btns {
  display: flex;
  justify-content: space-around;
  align-items: center;
  span {
    color: @primaryColor;
    font-size: 12px;
    cursor: pointer;
    &:first-child:hover {
      color: #67c23a;
    }
    &:last-child:hover {
      color: #f56c6c;
    }
  }
}
.delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 12px;
    color: @primaryColor;
    cursor: pointer;
  }
}
.img-content {
  width: 40px;
  height: 40px;
}
/deep/ .el-table__body-wrapper {
  overflow-y: auto;
}
.row-bg {
  .el-col-22 {
    .el-form {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}
/deep/ .user-name .el-input__inner {
  width: 100px;
}
/deep/ .paltform-name .el-input__inner {
  width: 120px;
}
/deep/ .option-width {
  // margin-left: 10px;
  .el-input {
    .el-input__inner {
      width: 120px;
    }
  }
}
.primary {
  color: #007acc;
}
.sign-form {
  .top-box,
  .bottom-box {
    display: flex;
    .item_bto {
      margin-left: 5px;
    }
  }
}
</style>